import React, { useEffect } from "react";
import { Card, Stack, Typography } from "@curves/ui-base";
import { inBodyInterviewNotesItems } from '@icoach/inbody/interview/InBodyInterviewMeasureNormalBox';
import { isEmpty } from '@util/utils';
import { MeasureInterviewLogTable } from '@icoach/inbody/components';

const InBodyInterviewNotesTable = React.forwardRef(({ sourceData: measureData = [], getInterviewMeasureApi }, ref) => {

    useEffect(() => {
            getInterviewMeasureApi();
        },
        // eslint-disable-next-line
        []);

    return (
        <Card>
            {!isEmpty(measureData) ? (
                <Card.CardContent>
                    <MeasureInterviewLogTable sourceData={measureData} measureItems={inBodyInterviewNotesItems} />
                </Card.CardContent>
            ) : (
                <Card.CardContent className={'p-3'}>
                    <Stack justifyContent={'center'} alignItems={'center'}>
                        <Typography variant="h6" className={'font-color-4'}>
                            無相關資料
                        </Typography>
                    </Stack>
                </Card.CardContent>
            )}
        </Card>
    );
});

export default InBodyInterviewNotesTable;
